<mat-toolbar class="mat-elevation-z6 navbar" [class.rtl]="!isEnglish" [class.ltr]="isEnglish" id="header">
  <button *ngIf="menuSizeState === 'hidden'" mat-icon-button class="menu-button" (click)="sidenavToggle()">
    <mat-icon>menu</mat-icon>
  </button>

  <span class="spacer"></span>

  <!-- Language Menu -->
  <button mat-button [matMenuTriggerFor]="languageMenu" class="no-padding font-color ml-6">
    <img
      *ngIf="selectedLanguage"
      [src]="selectedLanguage.flag"
      style="width:20px; height:14px; object-fit:cover; border-radius:2px; margin-right:6px;"
    />
    {{ selectedLanguage?.label }}
    <mat-icon class="font-color">arrow_drop_down</mat-icon>
  </button>

  <mat-menu #languageMenu="matMenu" class="header-menu" xPosition="before">
    <button
      mat-menu-item
      class="m-w-200 border-bottom font-color"
      *ngFor="let lang of languages"
      (click)="setLanguage(lang)"
    >
      <img [src]="lang.flag" style="width:20px; height:14px; object-fit:cover; border-radius:2px; margin-right:8px;" />
      <span>{{ lang.label }}</span>
    </button>
  </mat-menu>

  <!-- Permissions menu -->
  <ng-container *ngIf="checkPermission('create-permission')">
    <button mat-button [matMenuTriggerFor]="permissionsMenu" class="no-padding font-color ml-6">
      {{ 'common.registerPermissions' | translate }}
      <mat-icon class="font-color">arrow_drop_down</mat-icon>
    </button>
    <mat-menu #permissionsMenu="matMenu" class="header-menu" xPosition="before">
      <button mat-menu-item class="m-w-200 border-bottom font-color" (click)="openProfile('Individuals-destruction')">
        {{ 'common.permission1' | translate }}
      </button>
      <button mat-menu-item class="m-w-200 border-bottom font-color" (click)="openProfile('damaged-projects')">
        {{ 'common.permission2' | translate }}
      </button>
      <button mat-menu-item class="m-w-200 border-bottom font-color" (click)="openProfile('governmental-damaged')">
        {{ 'common.permission3' | translate }}
      </button>
      <button mat-menu-item class="m-w-200 border-bottom font-color" (click)="openProfile('commercial-damaged')">
        {{ 'common.permission4' | translate }}
      </button>
      <button mat-menu-item class="m-w-200 border-bottom font-color" (click)="openProfile('sorting-plant')">
        {{ 'common.permission5' | translate }}
      </button>
    </mat-menu>
  </ng-container>

  <!-- User profile menu -->
  <button mat-button [matMenuTriggerFor]="menu" class="no-padding font-color">
    <mat-icon class="font-color user-menu-profile-icon" svgIcon="user-menu"></mat-icon>
    {{ userName }}
    <mat-icon class="font-color">arrow_drop_down</mat-icon>
  </button>
  <mat-menu #menu="matMenu" class="header-menu" xPosition="before">
    <button mat-menu-item class="m-w-200 border-bottom font-color" (click)="openProfile('profile')">
      {{ 'common.profile' | translate }}
    </button>
    <button mat-menu-item class="link-color" (click)="logout()">
      {{ 'common.logout' | translate }}
    </button>
  </mat-menu>

  <mat-progress-bar
    #mainProgressBar
    id="mainProgressBar"
    mode="indeterminate"
    color="primary"
    class="position-relative"
    style="display: none;"
  ></mat-progress-bar>
</mat-toolbar>
